import { module } from 'modujs';
import { gsap } from 'gsap';
import { random, roundRandom } from '../utils/maths';

const MAX_ROTATION = 20;

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'next',
                prev: 'prev'
            }
        }

        this.$images = this.$('image');
        this.$imagesWrap = this.$('imageWrap')[0];
        this.$kisses = this.$('kisses')[0];
    }

    init() {

        this.isAvailable = true;

        this.currentIndex = this.$images.length - 1;

        this.$images.forEach(($image, index) => {
            $image.style.transform = `rotate(${(random(-MAX_ROTATION, MAX_ROTATION))}deg)`;

            if(index == this.currentIndex) {
                $image.classList.add('is-active');
            }
        });
        
    }

    next() {
        if(!this.isAvailable) return;

        this.change('next');
        let kissLength = roundRandom(3,6);

        for (let index = 0; index < kissLength; index++) {
            let $kiss = document.createElement('span');
            $kiss.classList.add('c-kiss');
            let width = roundRandom(50,100);
            $kiss.style.width = `${width}px`;
            $kiss.style.marginLeft = `-${width/2}px`;
            $kiss.style.marginTop = `-${width/2}px`;

            $kiss.style.bottom = `${(index*30)}px`;
            $kiss.style.left = `${random(-30, 130)}px`;
            $kiss.style.transform=`rotate(${random(-45, 45)}deg)`;

            
            gsap.delayedCall((index * 0.15), () => {
                this.$kisses.append($kiss);

                let tl = gsap.timeline();
                tl.fromTo($kiss,{
                    scale: 0,
                    alpha: 1,
                    y: '50%'
                },{
                    scale: 1,
                    alpha: 1,
                    y: 0,
                    duration: 0.4
                });
                tl.to($kiss,{
                    scale: 0.5,
                    alpha: 0,
                    duration: 0.4,
                    delay: 0.3
                });

                gsap.delayedCall(1.6, () => {
                    // $kiss.parentNode.removeChild($kiss);
                });
            });
            
        }

    }
    prev() {
        if(!this.isAvailable) return;

        this.change('prev');
    }

    change(direction) {

        if(!this.isAvailable) return;

        let offset = 1;
        if(direction == 'prev') {
            offset = -1;
        }

        this.isAvailable = false;
        this.$images = Array.from(this.el.querySelectorAll('[data-swipe="image"]'));

        this.$images.forEach(($image, index) => {
            if($image.classList.contains('is-active')) {
                $image.classList.remove('is-active');

                gsap.to($image,{
                    x: `${random(100,200) * offset}%`,
                    y: `-${random(10,50)}%`,
                    rotate:`${random(20, 60)*offset}deg`,
                    scale: `${random(1.1,1.4)}`,
                    alpha: 0,
                    duration: 0.6,
                    ease: 'power2.inOut',
                    onComplete: () => {
                        this.isAvailable = true;
                        this.$imagesWrap.prepend($image);

                        gsap.set($image,{
                            x: 0,
                            y:0,
                            rotate:`0deg`,
                            alpha: 0,
                            scale: 0,
                        });
                        gsap.to($image,{
                            alpha: 1,
                            scale: 1,
                            rotate:`${random(-MAX_ROTATION, MAX_ROTATION)}deg`,
                            duration: 0.6
                        });

                    }
                });
            }
            
            gsap.delayedCall(0.6,() => {

                if(index == this.currentIndex - 1) {
                    $image.classList.add('is-active');
                }
            });
        });
    }
}
